import CheckIcon from "../_icons/checkIcon";
import StopIcon from "../_icons/stopIcon";

export const SuccessBanner = () => {
  return (
    <div className="rounded-xl mx-4 bg-[#F2FCEE] border-[#276A16] border-[1px] p-4 flex items-center">
      <CheckIcon />
      <span className="ml-4">Items added to cart</span>
    </div>
  );
};

export const UnavailableBanner = ({ count }: any) => {
  return (
    <div className="rounded-xl mx-4 bg-[#FFF6CC] border-[#FFD100] border-[1px] p-4 flex items-center">
      <StopIcon />
      {count > 0 && (
        <span className="ml-4">
          {count} item(s) added to cart. Certain item(s) are unavailable and
          could not be added.
        </span>
      )}
      {count === 0 && (
        <span className="ml-4">
          Items are unavailable and could not be added to cart.
        </span>
      )}
    </div>
  );
};
